export default (function ($) {
  let _instance = {};

  /**
   * Initialize the method
   *
   * @return false
   */
  _instance.init = function () {
    $(document).ready(function () {
      $(document).on('click', '.caption-block .wkngp-icon--info', function () {
        $(this).parent().find('.caption-block__content').toggleClass('d-none');
      });

      $(document).on('click', '.caption-block .wkngp-icon--close', function () {
        $(this).parent().addClass('d-none');
      });
    });
  };

  return _instance;
})(jQuery);
